import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../reducers';
import { StyledBackground } from './styles';
import EditPanel from '../../../../containers/Editor/EditPanel';
import PageBackgroundPanel from '../../../../containers/Editor/EditPanel/PageBackgroundPanel';
import { EditableType } from '../../../../containers/Editor/constants';
import { setIsPageBackgroundActive } from '../../../../containers/Editor/actions';
import UserAgentUtils from '../../../../utils/userAgent';
import { Api } from '../../../../typings/api';

interface BackgroundProps {
	url: string;
	color: string | undefined;
	isHidden: boolean;
	isEditable: boolean;
	isActive: boolean;
	isEditPanelDisplayed: boolean;
	mediaType: Api.AssetItemFileTypes;
	editorContainer: Element | null;
	children: React.ReactNode;
	dispatch: Dispatch<StoreState>;
}

export const PAGE_BACKGROUND_CLICK_CLASS = 'page-background-click';

const panels = {
	[EditableType.image]: <PageBackgroundPanel type={EditableType.image} />,
	[EditableType.video]: <PageBackgroundPanel type={EditableType.video} />,
};

const isClickOnBackground = (e: MouseEvent | TouchEvent): boolean => {
	const element = e.target as HTMLElement;
	return element.className.includes(PAGE_BACKGROUND_CLICK_CLASS);
};

const getDefaultPanelType = (mediaType: Api.AssetItemFileTypes): EditableType => (
	mediaType === Api.AssetItemFileTypes.IMAGE ? EditableType.image : EditableType.video
);

const Background = ({
	url,
	color,
	isHidden,
	isEditable,
	isActive,
	isEditPanelDisplayed,
	mediaType,
	editorContainer,
	children,
	dispatch,
}: BackgroundProps) => {
	const handleClick = (e: MouseEvent | TouchEvent) => {
		if (!url || !isEditable || isActive) {
			return;
		}

		if (isClickOnBackground(e)) {
			dispatch(setIsPageBackgroundActive(true));
		}
	};

	React.useEffect(() => {
		if (!isActive) {
			return;
		}

		const handleWindowClick = (e: MouseEvent | TouchEvent) => {
			if (!isClickOnBackground(e)) {
				dispatch(setIsPageBackgroundActive(false));
			}
		};

		if (editorContainer) {
			editorContainer.addEventListener('mousedown', handleWindowClick);
		}

		return () => {
			if (editorContainer) {
				editorContainer.removeEventListener('mousedown', handleWindowClick);
			}
		};
	}, [isActive]);

	return (
		<StyledBackground
			isHidden={isHidden}
			url={url}
			color={color}
			isActive={isActive}
			isMobileApp={UserAgentUtils.isMobileApp}
			onClick={handleClick}
		>
			{isActive && isEditPanelDisplayed &&
				<EditPanel
					defaultType={getDefaultPanelType(mediaType)}
					panels={panels}
				/>
			}
			{children}
		</StyledBackground>
	);
};

export default Background;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Page/Background/index.tsx